export default __webpack_public_path__ + "static/media/logo.714cdde6.webp";